// extracted by mini-css-extract-plugin
var _1 = "EntityProfileTabUpdatesCardEntityLink-modulelink__Z0GZr";
export { _1 as "link" }
